var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container designer form-designer-page"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('avue-form-design',{ref:"formDesign",staticStyle:{"height":"calc(100vh - 185px)"},attrs:{"newOpenType":_vm.newOpenType,"options":_vm.options,"storage":"","show-avue-doc":""},on:{"submit":_vm.handleSubmit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }